import { render, staticRenderFns } from "./PatientNew.vue?vue&type=template&id=49bd0053&scoped=true&"
import script from "./PatientNew.vue?vue&type=script&lang=js&"
export * from "./PatientNew.vue?vue&type=script&lang=js&"
import style0 from "./PatientNew.vue?vue&type=style&index=0&id=49bd0053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd0053",
  null
  
)

export default component.exports